import { AGENTS_PATH } from "@amtana/agent-client";
import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { AGENT_CATALOGS } from "./model/agent-copy.ts";
import { AGENT_ERROR_COPY, AGENT_RUNTIME_ERROR_COPY, BROWSER_ERROR_COPY } from "./model/agent-error-copy.ts";
import { BROWSER_CATALOGS } from "./model/browser-copy.ts";

// The Agents area (ADR-023 §11-12): every screen and the sidebar entry need `remote-agents`; off,
// the screens are the not-found screen and the entry is absent, as every door answers not found.
export const agentBrowserModule: BrowserModule = defineBrowserModule("agent")
  .withErrorCopy({ ...AGENT_ERROR_COPY, ...AGENT_RUNTIME_ERROR_COPY, ...BROWSER_ERROR_COPY })
  .withScreens({
    agents: {
      path: AGENTS_PATH,
      title: phrase(AGENT_CATALOGS, "screenTitleList"),
      layout: "app",
      flag: "remote-agents",
      load: () => import("./ui/sections/agents-screen.tsx"),
    },
    agent: {
      path: `${AGENTS_PATH}/:agentId`,
      title: phrase(AGENT_CATALOGS, "screenTitleAgent"),
      layout: "app",
      flag: "remote-agents",
      load: () => import("./ui/sections/agent-screen.tsx"),
    },
    liveScreen: {
      path: `${AGENTS_PATH}/:agentId/screen`,
      title: phrase(BROWSER_CATALOGS, "screenTitleLive"),
      layout: "app",
      flag: "remote-agents",
      load: () => import("./ui/sections/agent-screen-live.tsx"),
    },
  })
  .withNavigation([
    {
      id: "agents",
      group: "leads",
      label: phrase(AGENT_CATALOGS, "navAgents"),
      href: AGENTS_PATH,
      icon: "bot",
      order: 150,
      activeFor: [`${AGENTS_PATH}/`],
      flag: "remote-agents",
    },
  ]);
